// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * KB extraction node admin view.
 * Delegates to AnalysisNodeShell for consistent UI across analysis node types.
 */
import type { FC } from 'react'
import type { NodeAdminViewProps } from '../../../../core/types'
import { AnalysisNodeShell } from '../AnalysisNodeShell'

export const AnalysisPromptAdminView: FC<NodeAdminViewProps> = props => (
  <AnalysisNodeShell
    {...props}
    title="Knowledge Base Analysis"
    description="Configure the model, prompt, and dataset emitted by the KB extraction node. This dataset feeds downstream summary nodes and dashboards, so keep the key stable (e.g., analysis_findings)."
    mode="extraction"
    allowedDatasourceTypes={['full_text', 'connector']}
  />
)
